import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const aircall = defineConnector({
  identifier: "aircall",
  name: "Aircall",
  tagLine: "Cloud-based call center and phone system",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.aircall\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiId,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Create an Aircall API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Aircall dashboard](https://dashboard.aircall.io/), go to **Company settings → API Keys** and create a new API key. Copy the generated API ID and API token.",
        },
      ],
    },
    {
      title: "Enter your Aircall credentials",
      items: [
        {
          kind: "input",
          label: "API ID",
          required: true,
          target: { kind: "configuration", field: "apiId" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.aircall.io/v1/ping",
  },
});
